import React from 'react';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import { useApp } from '../context/AppContext';

const SummaryCard = ({ title, amount, change, icon: Icon, variant = 'default', subtitle }) => {
  const { formatCurrency } = useApp();
  const isPositive = change >= 0;

  // Map variant to CSS class and icon colors
  const variantMap = {
    income:  { cls: 'card-income',  iconBg: 'rgba(255,255,255,0.2)',  iconColor: 'white' },
    expense: { cls: 'card-expense', iconBg: 'rgba(255,255,255,0.2)',  iconColor: 'white' },
    balance: { cls: 'card-balance', iconBg: 'rgba(255,255,255,0.2)',  iconColor: 'white' },
    default: { cls: 'card',         iconBg: 'var(--accent-light)',    iconColor: 'var(--accent)' },
  };

  const { cls, iconBg, iconColor } = variantMap[variant] || variantMap.default;
  const isGradient = variant !== 'default';

  return (
    <div
      className={`${cls} scale-in`}
      style={{ cursor: 'default' }}
    >
      {/* Top row: label + icon */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', position: 'relative', zIndex: 1 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{
            fontSize: '0.72rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            color: isGradient ? 'rgba(255,255,255,0.75)' : 'var(--text-muted)',
            marginBottom: '0.6rem',
          }}>
            {title}
          </p>

          <p style={{
            fontSize: '2.1rem',
            fontWeight: 900,
            color: isGradient ? 'white' : 'var(--text-primary)',
            letterSpacing: '-0.03em',
            lineHeight: 1.1,
            marginBottom: '0.35rem',
          }}>
            {formatCurrency(amount)}
          </p>

          {subtitle && (
            <p style={{
              fontSize: '0.78rem',
              color: isGradient ? 'rgba(255,255,255,0.65)' : 'var(--text-muted)',
              marginBottom: '0.75rem',
              fontWeight: 500,
            }}>
              {subtitle}
            </p>
          )}

          {/* Change badge */}
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.3rem',
            padding: '0.3rem 0.65rem',
            borderRadius: '999px',
            background: isGradient ? 'rgba(255,255,255,0.18)' : (isPositive ? 'var(--success-light)' : 'var(--danger-light)'),
            backdropFilter: 'blur(8px)',
            border: isGradient ? '1px solid rgba(255,255,255,0.2)' : 'none',
            fontSize: '0.75rem',
            fontWeight: 700,
            color: isGradient ? 'white' : (isPositive ? 'var(--success)' : 'var(--danger)'),
          }}>
            {isPositive ? <FaArrowUp size={10} /> : <FaArrowDown size={10} />}
            {Math.abs(change)}% vs last month
          </div>
        </div>

        {/* Icon bubble */}
        <div style={{
          width: '52px',
          height: '52px',
          borderRadius: '16px',
          background: iconBg,
          backdropFilter: 'blur(8px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          border: isGradient ? '1px solid rgba(255,255,255,0.25)' : '1px solid var(--border-glow)',
          boxShadow: isGradient
            ? '0 4px 16px rgba(0,0,0,0.15), 0 1px 0 rgba(255,255,255,0.3) inset'
            : '0 4px 16px var(--accent-light)',
          marginLeft: '1rem',
        }}>
          {Icon && <Icon size={22} color={iconColor} />}
        </div>
      </div>

      {/* Bottom glow line on gradient cards */}
      {isGradient && (
        <div style={{
          position: 'absolute',
          bottom: 0, left: '15%', right: '15%',
          height: '1px',
          background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
          zIndex: 1,
        }} />
      )}
    </div>
  );
};

export default SummaryCard;
